import { AppGlobalActions } from '@app/_store/actions/global.actions';
import { UnloadedMetaContainer } from '@core/models/general-types/general-types';
import { Banners } from '@core/models/interfaces/storage-data/banners';
import { createFeature, createReducer, on } from '@ngrx/store';

import { BannersActions } from './banners.actions';

export type BannersState = UnloadedMetaContainer<Banners>;

export const initialBannersState: BannersState = {
  collection: [],
  metaData: null,
};

const bannersReducer = createReducer(
  initialBannersState,
  on(AppGlobalActions.loadAppDataSuccess, (state, { globalState }) =>
    // R37. `...(globalState.banners ?? {})` produced a new state object even
    // when this container was not part of the response, so a one-container
    // load handed all 23 feature slices a new reference and nothing else.
    globalState.banners ? { ...state, ...globalState.banners } : state
  ),
  on(BannersActions.loadBannersSuccess, (state, { banners }) => ({
    ...state,
    ...banners,
  }))
);

export const bannersFeature = createFeature({
  name: 'banners',
  reducer: bannersReducer,
  extraSelectors: ({ selectBannersState }) => ({
    selectBannersState,
  }),
});
